<template>
  <div class="wincourse-load container">
    <div class="load-gif">
      <p>信息正在解析中,请稍等...</p>
    </div>
  </div>
</template>

<script>
import { verifyTicket } from "@/api/auth/jwt";
import { mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (newVal, old) {
        if (newVal !== old) {
          if (Object.keys(newVal.query).length !== 0) {
            const { ticket = "" } = newVal.query;
            this.verifyTicket(ticket, newVal.params.code);
          }
        }
      },
    },
  },
  methods: {
    ...mapActions(["LogOut"]),
    verifyTicket(ticket, code) {
      verifyTicket(ticket)
        .then((res) => {
          this.$store.dispatch("setToken", res.accessToken);
          this.$store.dispatch("GetUserInfo");
          this.$router.replace(`/lesson/${code}/type/exp`);
        })
        .catch(() => {
          this.LogOut()
          this.$router.replace("/");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.wincourse-load {
  .load-gif {
    width: 600px;
    height: 175px;
    margin: 0 auto;
    margin-top: 260px;
    background: url("~@/assets/imgs/wincourse/load-animation.gif") no-repeat;
    text-align: center;
    padding-top: 135px;
    p {
    }
  }
}
</style>

